import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.10",
  "description": "Turborepo 1.10 introduces new features to improve your local development experience.",
  "date": "2023/06/01",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.10 introduces new features to improve your local development experience:"
  }, {
    "heading": "",
    "content": "Code Generators: Use turbo gen to generate source code, including creating new workspaces and copying existing ones."
  }, {
    "heading": "",
    "content": "Improved Environment Variable Inputs: It's now easier to depend on environment variables with wildcards and .env support."
  }, {
    "heading": "",
    "content": "New Environment Modes: You can now specify --env-mode=strict to control environment variables that are included in your task hashes."
  }, {
    "heading": "",
    "content": "Update today with"
  }, {
    "heading": "code-generators",
    "content": "Turborepo Generators allow you to add new code to your repository in a predictable, structured way.\nPreviously, you would need to copy code yourself and manually add dependencies to your new workspace. With Generators,\nwe've automated the process of creating new workspaces and integrating them into your repository."
  }, {
    "heading": "code-generators",
    "content": "You can create a blank workspace from scratch, copy an existing workspace, or even create custom generators\nfor more control. Custom generators leverage Plop configurations, a common template definition strategy used in the JavaScript ecosystem."
  }, {
    "heading": "code-generators",
    "content": "Custom generators can also be used to scaffold more granular sets of code than workspaces. You can significantly speed up tasks like:"
  }, {
    "heading": "code-generators",
    "content": "Adding new components to your UI library"
  }, {
    "heading": "code-generators",
    "content": "Creating new unit tests"
  }, {
    "heading": "code-generators",
    "content": "Generating a new MDX blog post"
  }, {
    "heading": "code-generators",
    "content": "Get started with your first generator by running:"
  }, {
    "heading": "code-generators",
    "content": "For more, check out the documentation."
  }, {
    "heading": "support-for-env-files",
    "content": ".env files are commonly used to load environment variables. This can cause problems when running with turbo, because these variables can be invisible, and are not easily\nincluded in the hash for your task. This problem could cause unintended cache hits while working locally."
  }, {
    "heading": "support-for-env-files",
    "content": "Turborepo now makes this much easier with automatic support for .env files."
  }, {
    "heading": "support-for-env-files",
    "content": "To ensure that Turborepo includes these variables in your hash, use the dotEnv key. For example, here is a configuration for a Next.js application:"
  }, {
    "heading": "support-for-env-files",
    "content": "This feature does not handle system environment variables. If you are not\nusing .env files outside of development, make sure your environment\nvariables are still enumerated in either\nenv, or\nglobalEnv to ensure they are\nincluded in your hash."
  }, {
    "heading": "support-for-env-files",
    "content": "For more, check out the documentation."
  }, {
    "heading": "environment-variable-wildcards",
    "content": "Large applications can end up with many environment variables in their turbo.json. This can make your configuration difficult to manage and maintain."
  }, {
    "heading": "environment-variable-wildcards",
    "content": "With wildcards, you can now specify patterns of variables to include in your hash."
  }, {
    "heading": "environment-variable-wildcards",
    "content": "For more, check out the documentation."
  }, {
    "heading": "environment-modes",
    "content": "Turborepo environment modes are now out of experimental mode and are available for general use."
  }, {
    "heading": "environment-modes",
    "content": "By default, and when turbo run is invoked with --env-mode=loose, all environment variables from the machine are made available to every single Turborepo task.\nThis ensures the greatest compatibility while accepting some risk that a task will implicitly have access to a environment variable that is not specified in your turbo.json."
  }, {
    "heading": "environment-modes",
    "content": "In the new strict mode, when turbo is invoked with --env-mode=strict, only important system environment variables and environment variables enumerated inside of turbo.json will be made available to a task."
  }, {
    "heading": "environment-modes",
    "content": "For more, check out the documentation."
  }, {
    "heading": "community",
    "content": "Since releasing Turborepo v1.9 we've seen incredible adoption and community growth:"
  }, {
    "heading": "community",
    "content": "21.5k+ GitHub Stars"
  }, {
    "heading": "community",
    "content": "1.2M+ weekly NPM downloads"
  }, {
    "heading": "community",
    "content": "85 years of compute time saved through Remote Caching on Vercel"
  }, {
    "heading": "community",
    "content": "Turborepo is the result of the combined work of all of its contributors, including our core team:"
  }, {
    "heading": "community",
    "content": "Jared, Greg, Nathan, Thomas, Mehul, Chris, Nicholas, and Alexander"
  }, {
    "heading": "community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
  }],
  "headings": [{
    "id": "code-generators",
    "content": "Code Generators"
  }, {
    "id": "improved-environment-variable-inputs",
    "content": "Improved Environment Variable Inputs"
  }, {
    "id": "support-for-env-files",
    "content": "Support for .env files"
  }, {
    "id": "environment-variable-wildcards",
    "content": "Environment Variable Wildcards"
  }, {
    "id": "environment-modes",
    "content": "Environment modes"
  }, {
    "id": "community",
    "content": "Community"
  }]
};
import {Authors} from '#components/authors';
import {Callout} from '#components/callout';
import {ThemeAwareImage} from '#components/theme-aware-image';
import {Date} from '#components/blog/date';
export const toc = [{
  depth: 2,
  url: "#code-generators",
  title: _jsx(_Fragment, {
    children: "Code Generators"
  })
}, {
  depth: 2,
  url: "#improved-environment-variable-inputs",
  title: _jsx(_Fragment, {
    children: "Improved Environment Variable Inputs"
  })
}, {
  depth: 3,
  url: "#support-for-env-files",
  title: _jsxs(_Fragment, {
    children: ["Support for ", _jsx("code", {
      children: ".env"
    }), " files"]
  })
}, {
  depth: 3,
  url: "#environment-variable-wildcards",
  title: _jsx(_Fragment, {
    children: "Environment Variable Wildcards"
  })
}, {
  depth: 3,
  url: "#environment-modes",
  title: _jsx(_Fragment, {
    children: "Environment modes"
  })
}, {
  depth: 2,
  url: "#community",
  title: _jsx(_Fragment, {
    children: "Community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.10"
    }), "\n", "\n", _jsx(Date, {
      children: "Thursday, June 1st, 2023"
    }), "\n", _jsx(Authors, {
      authors: ['nathanhammond', 'tomknickman', 'anthonyshew', 'mehulkar']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 1.10 introduces new features to improve your local development experience:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#code-generators",
          children: _jsx(_components.strong, {
            children: "Code Generators"
          })
        }), ": Use ", _jsx(_components.code, {
          children: "turbo gen"
        }), " to generate source code, including creating new workspaces and copying existing ones."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#improved-environment-variable-inputs",
          children: _jsx(_components.strong, {
            children: "Improved Environment Variable Inputs"
          })
        }), ": It's now easier to depend on environment variables with wildcards and ", _jsx(_components.code, {
          children: ".env"
        }), " support."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#environment-modes",
          children: _jsx(_components.strong, {
            children: "New Environment Modes"
          })
        }), ": You can now specify ", _jsx(_components.code, {
          children: "--env-mode=strict"
        }), " to control environment variables that are included in your task hashes."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Update today with"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @turbo/codemod"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " migrate"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "code-generators",
      children: "Code Generators"
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 rounded-xl border-2 border-[#f3f7fd] p-4 dark:border-[#1c2428]",
      light: {
        alt: 'turbo-gen',
        src: '/images/blog/turbo-1-10-0/turbo-gen-light.gif',
        props: {
          width: 600,
          height: 205
        }
      },
      dark: {
        alt: 'turbo-gen',
        src: '/images/blog/turbo-1-10-0/turbo-gen-dark.gif',
        props: {
          width: 600,
          height: 215
        }
      }
    }), "\n", _jsx(_components.p, {
      children: "Turborepo Generators allow you to add new code to your repository in a predictable, structured way.\nPreviously, you would need to copy code yourself and manually add dependencies to your new workspace. With Generators,\nwe've automated the process of creating new workspaces and integrating them into your repository."
    }), "\n", _jsxs(_components.p, {
      children: ["You can ", _jsx(_components.a, {
        href: "/docs/guides/generating-code#add-an-empty-package",
        children: "create a blank workspace from scratch"
      }), ", ", _jsx(_components.a, {
        href: "/docs/guides/generating-code#copy-an-existing-package",
        children: "copy an existing workspace"
      }), ", or even create custom generators\nfor more control. Custom generators leverage ", _jsx(_components.a, {
        href: "https://plopjs.com/",
        children: "Plop"
      }), " configurations, a common template definition strategy used in the JavaScript ecosystem."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/guides/generating-code#custom-generators",
        children: "Custom generators"
      }), " can also be used to scaffold more granular sets of code than workspaces. You can significantly speed up tasks like:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/blob/main/examples/basic/packages/ui/turbo/generators/config.ts",
          children: "Adding new components to your UI library"
        })
      }), "\n", _jsx(_components.li, {
        children: "Creating new unit tests"
      }), "\n", _jsx(_components.li, {
        children: "Generating a new MDX blog post"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Get started with your first generator by running:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["For more, check out the ", _jsx(_components.a, {
        href: "/docs/guides/generating-code",
        children: "documentation"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "improved-environment-variable-inputs",
      children: "Improved Environment Variable Inputs"
    }), "\n", _jsxs(_components.h3, {
      id: "support-for-env-files",
      children: ["Support for ", _jsx(_components.code, {
        children: ".env"
      }), " files"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "https://www.dotenv.org/docs/",
        children: [_jsx(_components.code, {
          children: ".env"
        }), " files"]
      }), " are commonly used to load environment variables. This can cause problems when running with ", _jsx(_components.code, {
        children: "turbo"
      }), ", because these variables can be ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#avoid-creating-or-mutating-environment-variables-at-runtime",
        children: "invisible"
      }), ", and are not easily\nincluded in the hash for your task. This problem could cause unintended cache hits while working locally."]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo now makes this much easier with automatic support for ", _jsx(_components.code, {
        children: ".env"
      }), " files."]
    }), "\n", _jsxs(_components.p, {
      children: ["To ensure that Turborepo includes these variables in your hash, use the ", _jsx(_components.code, {
        children: "dotEnv"
      }), " key. For example, here is a configuration for a Next.js application:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turborepo.com/schema.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalDotEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dotEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env.production.local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env.local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env.production\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dotEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env.development.local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env.local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env.development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \".env\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dotEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env.test.local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".env.test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      children: _jsxs(_components.p, {
        children: ["This feature does ", _jsx(_components.strong, {
          children: "not"
        }), " handle system environment variables. If you are not\nusing ", _jsx(_components.code, {
          children: ".env"
        }), " files outside of development, make sure your environment\nvariables are still enumerated in either\n", _jsx(_components.a, {
          href: "/docs/reference/configuration#env",
          children: "env"
        }), ", or\n", _jsx(_components.a, {
          href: "/docs/reference/configuration#globalenv",
          children: "globalEnv"
        }), " to ensure they are\nincluded in your hash."]
      })
    }), "\n", _jsx(_components.p, {
      children: "For more, check out the documentation."
    }), "\n", _jsx(_components.h3, {
      id: "environment-variable-wildcards",
      children: "Environment Variable Wildcards"
    }), "\n", _jsxs(_components.p, {
      children: ["Large applications can end up with many environment variables in their ", _jsx(_components.code, {
        children: "turbo.json"
      }), ". This can make your configuration difficult to manage and maintain."]
    }), "\n", _jsx(_components.p, {
      children: "With wildcards, you can now specify patterns of variables to include in your hash."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turborepo.com/schema.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"ACME_*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["For more, check out the ", _jsx(_components.a, {
        href: "/docs/reference/configuration#wildcards",
        children: "documentation"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "environment-modes",
      children: "Environment modes"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo environment modes are now out of experimental mode and are available for general use."
    }), "\n", _jsxs(_components.p, {
      children: ["By default, and when ", _jsx(_components.code, {
        children: "turbo run"
      }), " is invoked with ", _jsx(_components.code, {
        children: "--env-mode=loose"
      }), ", all environment variables from the machine are made available to every single Turborepo task.\nThis ensures the greatest compatibility while accepting some risk that a task will implicitly have access to a environment variable that is not specified in your ", _jsx(_components.code, {
        children: "turbo.json"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["In the new strict mode, when ", _jsx(_components.code, {
        children: "turbo"
      }), " is invoked with ", _jsx(_components.code, {
        children: "--env-mode=strict"
      }), ", only ", _jsx(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: "important system environment variables"
      }), " and environment variables enumerated inside of ", _jsx(_components.code, {
        children: "turbo.json"
      }), " will be made available to a task."]
    }), "\n", _jsxs(_components.p, {
      children: ["For more, check out the ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#environment-modes",
        children: "documentation"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "community",
      children: "Community"
    }), "\n", _jsxs(_components.p, {
      children: ["Since releasing ", _jsx(_components.a, {
        href: "/blog/turbo-1-9-0",
        children: "Turborepo v1.9"
      }), " we've seen incredible adoption and community growth:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "21.5k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "1.2M+ weekly NPM downloads"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["85 years of compute time saved through ", _jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Remote Caching on Vercel"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo is the result of the combined work of all of its contributors, including our core team:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://github.com/jaredpalmer",
          children: "Jared"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/gsoltis",
          children: "Greg"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/nathanhammond",
          children: "Nathan"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/tknickman",
          children: "Thomas"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/mehulkar",
          children: "Mehul"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/chris-olszewski",
          children: "Chris"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/NicholasLYang",
          children: "Nicholas"
        }), ", and ", _jsx(_components.a, {
          href: "https://github.com/arlyon",
          children: "Alexander"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
